import React from 'react';
import { useSelector } from 'react-redux';
import ReportCardStats from './ReportCardStats';
import { selectReports } from './reportsSlice';
import { PURCHASE_CREDIT, SELL_CREDIT } from '../../constant/variables';

const ReportStatsCollections = () => {
  const reports = useSelector(selectReports);
  const wallet = useSelector((state) => state.wallet);

  if (reports.length === 0) {
    return null; // or some loading state
  }

  const totalCreditSold = reports
    .filter((report) => report.eventType === SELL_CREDIT)
    .reduce((acc, report) => acc + report.amount, 0);
  const totalCreditPurchased = reports
    .filter((report) => report.eventType === PURCHASE_CREDIT)
    .reduce((acc, report) => acc + report.amount, 0);

  return (
    <div>
      <dl className="mt-5 flex flex-col lg:flex-row lg:space-x-4">
        <ReportCardStats
          name="Total Credit Sold"
          value={parseFloat(totalCreditSold).toFixed(2)}
          type="total_sold"
        >
          {' '}
        </ReportCardStats>
        <ReportCardStats
          name="Total Credit Purchased"
          value={parseFloat(totalCreditPurchased).toFixed(2)}
          type="total_sold"
        >
          {' '}
        </ReportCardStats>
        <ReportCardStats
          name="Wallet Balance"
          value={parseFloat(wallet?.data?.amount).toFixed(2)}
          type="total_sold"
        >
          {' '}
        </ReportCardStats>
      </dl>
    </div>
  );
};

export default ReportStatsCollections;
